import { createSlice } from '@reduxjs/toolkit'

export const editIDSlice = createSlice({
  name: 'editID',
  initialState: {
    value: ''
  },
  reducers: {
    updateEditID: (state, action) => {
      state.value = action.payload;
    }
  }
})

export const { updateEditID } = editIDSlice.actions

export const selectEditID = (state) => state.editID.value

export default editIDSlice.reducer